module.exports = {
    primary: [
        '#000C66', // highlighted text
        '#000000', // Header
        '#6B8BA1', // Links
        '#E45757', // ?
    ],
}


